// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2PwQ5","imageUploader":"EGiftCard_imageUploader__1gqcT"};